export default "__VITE_ASSET__e53a066a__"